import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

/**
 * Contextual empty-state wrapper.
 *
 * Passes through to `<bodyanalytics-empty-state>`.  All inputs are optional and
 * default to the generic "No data available." treatment so existing usages stay
 * unchanged.
 *
 * @example
 * <bodyanalytics-default-empty-data-container
 *   icon="bx-calendar-x"
 *   heading="No events scheduled"
 *   message="Create your first testing event to get started."
 *   ctaLabel="Create Event"
 *   [ctaLink]="createEventRoute">
 * </bodyanalytics-default-empty-data-container>
 */
@Component({
  selector: 'bodyanalytics-default-empty-data-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmptyStateComponent, RouterLink],
  templateUrl: './default-empty-data-container.component.html',
  styleUrl: './default-empty-data-container.component.scss',
})
export class DefaultEmptyDataContainerComponent {
  /** Boxicons glyph class. Defaults to the generic inbox icon. */
  icon = input('bx-inbox');
  /** Primary heading of the empty state. */
  heading = input('No data available.');
  /** Optional supporting message shown beneath the heading. */
  message = input<string>();
  /** Label for the optional primary CTA button. Requires `ctaLink`. */
  ctaLabel = input<string>();
  /** Router path for the optional CTA.  Requires `ctaLabel`. */
  ctaLink = input<string | string[]>();
}
